// extracted by mini-css-extract-plugin
module.exports = {"removeCashbackArea":"styles_removeCashbackArea__a_JRR","removeCashback":"styles_removeCashback__1IOzP"};